export { _getIssuesSummaryTypesConfig as getIssuesSummaryTypesConfig };

const _getIssuesSummaryTypesConfig = () => {
  // return null; // Page should not break. If returned null, it will be empty page with header.
  // Todo: Should return default valid object if API fails as this will define menu on the page.
  //   return [
  //     {
  //       label: "No Data Tab Title",
  //       id: "d2aad85a-5e48-4715-a9cf-58c84e511111",
  //       isActive: true,
  //       gridColumn: 1, // Optional, default:3
  //       profile: [
  //         {
  //           type: "nodatamessage",
  //           title: "No data",
  //           body: "No data set default message.",
  //         },
  //       ],
  //     },
  //   ];
  // Todo: Should validate API results including profile and proper headlineParams based on showVerifiedEvents or other settings.
  return [
    {
      label: "Our View",
      id: "d2aad85a-5e48-4715-a9cf-58c84e5004bd",
      isActive: true,
      showFutureEvents: false,
      profile: [
        {
          type: "overview",
          title: "Overview",
          body:
            "Lorem Ipsum Our View overview is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum. Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum. Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum. Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.",
        },
        {
          type: "background",
          title: "Background",
          body:
            "Lorem Ipsum Our View background is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum. Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum. Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum. Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.",
        },
      ],
      headlineParams: {
        showVerifiedEvents: false,
        commonWOD: {
          //   bounds: "",
          //   boundsType: "",
        },
        analysisWOD: {
          eventType: "all",
          sources: "analysis",
        },
        // verifiedEventsWOD: {
        //   eventType: "verified",
        //   sources: "political,maritime",
        // },
      },
    },
    {
      label: "Terrorism",
      id: "bdc6301a-93ca-47da-9d24-2bb1c8d976da",
      isActive: true,
      showFutureEvents: false,
      profile: [
        {
          type: "overview",
          title: "Overview",
          body:
            "Lorem Ipsum Terrorism overview is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.",
        },
        {
          type: "background",
          title: "Background",
          body:
            "Lorem Ipsum Terrorism background is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.",
        },
      ],
      headlineParams: {
        showVerifiedEvents: true,
        commonWOD: {
          //   bounds: "",
          //   boundsType: "",
        },
        analysisWOD: {
          eventType: "all",
          sources: "analysis",
          riskCategories: "e0a13937-4947-410a-971c-287f15068d88",
        },
        verifiedEventsWOD: {
          eventType: "verified",
          sources: "political,maritime",
          topics: "political_terrorism,maritime_terrorism",
        },
      },
    },
    {
      label: "Kidnap",
      id: "8fc66ea8-1638-4ff6-8bf0-988c02a0c15f",
      isActive: true,
      showFutureEvents: false,
      profile: [
        {
          type: "overview",
          title: "Overview",
          body:
            "Lorem Ipsum Kidnap overview is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.",
        },
        {
          type: "background",
          title: "Background",
          body:
            "Lorem Ipsum Kidnap background is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.",
        },
      ],
      headlineParams: {
        showVerifiedEvents: false,
        commonWOD: {
          //   bounds: "",
          //   boundsType: "",
        },
        analysisWOD: {
          eventType: "all",
          sources: "analysis",
          riskCategories: "8b3def4a-44e3-473a-9cc9-79a2e2539311",
        },
        // verifiedEventsWOD: {
        //   eventType: "verified",
        //   sources: "political,maritime",
        // },
      },
    },
    {
      label: "Activism",
      id: "108895f9-22f0-4032-bd59-58f2210c43ec",
      isActive: true,
      showFutureEvents: false,
      profile: [
        {
          type: "overview",
          title: "Overview",
          body:
            "Lorem Ipsum Activism overview is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.",
        },
        {
          type: "background",
          title: "Background",
          body:
            "Lorem Ipsum Activism background is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.",
        },
      ],
      headlineParams: {
        showVerifiedEvents: true,
        commonWOD: {
          //   bounds: "",
          //   boundsType: "",
        },
        analysisWOD: {
          eventType: "all",
          sources: "analysis",
          riskCategories: "",
        },
        verifiedEventsWOD: {
          eventType: "verified",
          sources: "political,maritime",
          topics: "activism",
        },
      },
    },
    {
      label: "Grid only headlines + overview",
      id: "a773dcde-4e0e-41a5-b0f4-890a968f0e6b",
      gridColumn: 2,
      isActive: true,
      showFutureEvents: false,
      profile: [
        {
          type: "overview",
          title: "Overview",
          body:
            "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.",
        },
        // {
        //   type: "background",
        //   title: "Background",
        //   body:
        //     "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.",
        // },
      ],
      headlineParams: {
        showAnalysisOnly: true,
        showVerifiedEvents: false,
        commonWOD: {
          //   bounds: "",
          //   boundsType: "",
        },
        analysisWOD: {
          eventType: "all",
          sources: "analysis",
          riskCategories: "",
        },
        // verifiedEventsWOD: {
        //   eventType: "verified",
        //   sources: "political,maritime",
        // },
      },
    },
    {
      label: "Grid only profile sample",
      id: "d2aad85a-5e48-4715-a9cf-58c84e511111",
      isActive: true,
      gridColumn: 2, // Optional, default:3
      profile: [
        {
          type: "overview",
          title: "Overview",
          body:
            "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.",
        },
        {
          type: "background",
          title: "Background",
          body:
            "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.",
        },
      ],
    },
    {
      label: "Grid only one profile section",
      id: "d2aad85a-5e48-4715-a9cf-58c84e522222",
      isActive: true,
      gridColumn: 1, // Optional, default:3
      profile: [
        {
          type: "overview",
          title: "Overview",
          body:
            "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.",
        },
        //   {
        //     type: "background",
        //     title: "Background",
        //     body:
        //       "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.",
        //   },
      ],
    },
  ];
};
